import React, { useState } from 'react';
import { GestureResponderEvent, ImageBackground, StyleSheet, Text, View, TouchableWithoutFeedback, TouchableOpacity } from 'react-native';
import { useDimensions } from 'react-native-web-hooks';
import Game from '../shell/Game';
import useFontSize from '../shell/hooks/useFontSize';
import { onDiscordPressed } from '../shell/utils/appManagementFunctions';
import { WaitForLoadImage } from '../shell/ImageHandler/WaitForLoadImage';
import { useAppSelector } from '../store/hooks';
import { selectMenu, setMenu } from '../store/slices/menuSlice';
import { store } from '../store/store';
import { parseRequire } from '../utils/parseImageUrl';
import { Disclaimer } from './Disclaimer';

interface StarterScreenProps {
}

export const StarterScreen: React.FC<StarterScreenProps> = ({ }) => {
    const image = parseRequire(require("@lss/common/game/assets/images/Extras/608_7.webp"));
    const menuSlice = useAppSelector(selectMenu);
    const [clickedDisclaimer, setClickedDisclaimer] = useState(false);
    const { width, height } = useDimensions().window;
    const styles = StyleSheet.create({
        container: {
            backgroundColor: "black",
            position: "absolute",
            width: "100%",
            height: "100%",
            zIndex: 1001,
        },
        backgroundImage: {
            position: "absolute",
            width: undefined,
            height,
            justifyContent: "center"
        },
        textWrapper: {
            backgroundColor: "#00000080",
            padding: "10%",
            flex: 1,
            width: "100%",
            alignItems: "center",
            flexDirection: "row",
            alignSelf: "center",
            textAlign: "center",
            justifyContent: "center",
            alignContent: "center"
        },
        text: {
            fontFamily: "serif",
            fontWeight: "bold",
            textShadowColor: 'rgba(0, 0, 0, 0.5)',
            textShadowRadius: 1,
            textShadowOffset: { width: 1, height: 1 },
            textAlign: "center",
            color: "white",
            display: "flex",
            flexDirection: "column",
            fontSize: useFontSize(4)
        },
        smallText: {
            fontSize: useFontSize(2.5)
        }

    });
    const _onDiscordPressed = (event: GestureResponderEvent) => {
        event.preventDefault();
        event.stopPropagation();
        onDiscordPressed();
    };
    const onBackgroundClicked = (event: GestureResponderEvent) => {
        event.preventDefault();
        event.stopPropagation();
        if (!clickedDisclaimer) {
            setClickedDisclaimer(true);
        } else {

            store.dispatch(setMenu({ showStarterScreen: false, display: true }));
        }
    };
    return (
        <View style={styles.container}>
            <TouchableWithoutFeedback style={styles.backgroundImage} onPress={(e) => onBackgroundClicked(e)}>
                {!clickedDisclaimer ?
                    <View>
                        <Disclaimer></Disclaimer>
                    </View>
                    :
                    <View>
                        <WaitForLoadImage duration={1500} style={styles.backgroundImage} source={image}>

                            <View style={styles.textWrapper}>

                                <Text selectable={false} style={styles.text}>
                                    <Text style={{ color: "#ff2d2d" }}>Important message!</Text>
                                    <Text style={{ flexDirection: "row", }}>
                                        {"\n"}
                                        Thank you for choosing to play the <Text style={{ fontStyle: "italic" }}>early access</Text> version of <Text style={{ color: "red" }}>Long Story Short!</Text>
                                        {/* {"\n"}If you want a complete and more fluid experience you may want to wait for the FULL release.{"\n"} */}
                                        {"\n"}
                                        <Text style={styles.smallText}>
                                            I would greatly appreciate it if you would report any bugs or instabilities you encounter to me (TTrick) in my <Text onPress={_onDiscordPressed} style={{ color: "#5865f2", zIndex: 5, }}>Discord</Text> server (engine-bugs channel).{"\n"}{"\n"}
                                            I hope you enjoy!
                                        </Text>

                                    </Text>
                                </Text>
                            </View>
                            {/* <View style={styles.textWrapper}>

                                <Text selectable={false} style={styles.text}>
                                    <Text style={{ color: "#ff2d2d" }}>Important message!</Text>
                                    <Text style={{ flexDirection: "row", }}>
                                        {"\n"}
                                        This <Text style={{ fontStyle: "italic" }}>alpha</Text> version is for my Patrons only.
                                        {"\n"}There is incomplete content, (paths, dialogue, no new animations, etc.).
                                        {"\n"}If you want a complete and more fluid experience you may want to wait for the FULL release.{"\n"}
                                        {"\n"}
                                        <Text style={styles.smallText}>
                                            If you choose to continue, I would greatly appreciate it if you would report any bugs or instabilities you encounter to me (TTrick) in my <Text onPress={_onDiscordPressed} style={{ color: "#5865f2", zIndex: 5, }}>Discord</Text> server (engine-bugs channel).{"\n"}{"\n"}
                                            I hope you enjoy!
                                        </Text>

                                    </Text>
                                </Text>
                            </View> */}
                            {/* 
                        <View style={styles.textWrapper}>

                            <Text selectable={false} style={styles.text}>
                                <Text style={{ flexDirection: "row", }}>
                                    Thank you for trying out the new engine for <Text style={{ color: "red" }}>Long Story Short!</Text>{"\n"}{"\n"}
                                    The engine is currently in an <Text style={{ fontStyle: "italic" }}>alpha</Text> state and is subject to change!{"\n"}
                                    I would greatly appreciate it if you would report any bugs or instabilities you encounter to me (TTrick) in my <Text onPress={_onDiscordPressed} style={{ color: "#5865f2", zIndex: 5, }}>Discord</Text> server (engine-bugs channel).{"\n"}{"\n"}
                                    I hope you enjoy!

                                </Text>
                            </Text>
                        </View> */}
                        </WaitForLoadImage>
                    </View>
                }
            </TouchableWithoutFeedback>
        </View>
    );
};